import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import FooterToolBar from '../../../components/tool/FooterToolBar.vue';
import selectGroupVue from '@/components/commonAdd/selectGroupGoods.vue';
import { Empty } from 'ant-design-vue';
import { saveGoodsGrouped, getGoodsGroupedDetail } from '@/services/product/goodsGrouped.js';
export default {
  components: {
    StandardTableVue: StandardTableVue,
    FooterToolBar: FooterToolBar,
    selectGroupVue: selectGroupVue
  },
  i18n: require("./i18n-group"),
  data: function data() {
    var _this = this;
    var columns = [{
      dataIndex: 'productNo',
      title: this.$t('account.goodsNumber')
    }, {
      title: this.$t('account.goodsName'),
      dataIndex: 'productName',
      scopedSlots: {
        customRender: 'productName'
      }
    }, {
      title: this.$t("publicuse.status"),
      dataIndex: 'productStatus',
      scopedSlots: {
        customRender: 'productStatus'
      }
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      form: {
        groupName: ''
      },
      saveData: [],
      loadingSave: false,
      columns: columns,
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['5', '10', '20'],
        total: 4,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total')).concat(total);
        },
        pageSize: 5,
        current: 1,
        showSizeChanger: true
      },
      sarchValue: '',
      addList: [],
      editID: null,
      alreadySelect: []
      // isDisabled:false
    };
  },
  computed: {
    data: function data() {
      var _this2 = this;
      if (this.sarchValue == '') {
        return this.saveData;
      } else {
        return this.saveData.filter(function (item) {
          return item.productNo.indexOf(_this2.sarchValue) !== -1 || item.productName.indexOf(_this2.sarchValue) !== -1;
        });
      }
    }
  },
  mounted: function mounted() {
    this.editID = this.$route.query['groupId'];
    if (this.editID) {
      this.initData();
    }
    // this.isDisabled = this.$route.query['name'] ? true : false
  },
  methods: {
    initData: function initData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.loadingTable = true;
              _context.p = 1;
              _context.n = 2;
              return getGoodsGroupedDetail(_this3.editID);
            case 2:
              res = _context.v;
              console.log(res, 'res...');
              if (res.data.code == 200) {
                _this3.saveData = res.data.data.productList;
                _this3.alreadySelect = res.data.data.productList.map(function (item) {
                  return item.optionId;
                });
                _this3.form.groupName = res.data.data.groupName;
              }
            case 3:
              _context.p = 3;
              _this3.loadingTable = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 3, 4]]);
      }))();
    },
    addEdit: function addEdit(row) {
      var _this4 = this;
      this.$nextTick(function () {
        // this.$refs.selectModal.selectedRowKeys = this.saveData.map(item => item.optionId)
        _this4.$refs.selectModal.visible = true;
        // this.total = this.saveData.length
      });
    },
    deleteGroup: function deleteGroup() {},
    confirmDelete: function confirmDelete(e) {
      this.saveData = this.saveData.filter(function (item) {
        return item.optionId !== e.optionId;
      });
      this.alreadySelect = this.saveData.map(function (item) {
        return item.optionId;
      });
      this.pagination.total = this.saveData.length;
    },
    cancelDelete: function cancelDelete() {},
    changePage: function changePage(e) {
      console.log(e);
    },
    showSizeChange: function showSizeChange(e) {
      console.log(e);
    },
    save: function save() {
      var _this5 = this;
      var flag = true;
      this.saveData.forEach(function (item) {
        if (item.productStatus == 2) {
          flag = false;
        }
      });
      if (flag) {
        this.$refs.formModel.validate(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
            var params, res;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  if (!valid) {
                    _context2.n = 4;
                    break;
                  }
                  _this5.loadingSave = true;
                  //  保存分组 所需参数

                  if (_this5.editID) {
                    params = {
                      groupId: _this5.editID,
                      groupName: _this5.form.groupName,
                      productOptionIds: _this5.saveData.map(function (item) {
                        return item.optionId;
                      })
                    };
                  } else {
                    params = {
                      groupName: _this5.form.groupName,
                      productOptionIds: _this5.saveData.map(function (item) {
                        return item.optionId;
                      })
                    };
                  }
                  _context2.p = 1;
                  _context2.n = 2;
                  return saveGoodsGrouped(params);
                case 2:
                  res = _context2.v;
                  if (res.data.code == 200) {
                    _this5.editID = res.data.data;
                    _this5.$message.success(_this5.$t('public.saveSuccessfully'));
                  }
                case 3:
                  _context2.p = 3;
                  _this5.loadingSave = false;
                  return _context2.f(3);
                case 4:
                  return _context2.a(2);
              }
            }, _callee2, null, [[1,, 3, 4]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.$message.error(this.$t('account.message1'));
      }
    },
    confirmProduct: function confirmProduct(data) {
      this.saveData = data;
      this.alreadySelect = data.map(function (item) {
        return item.optionId;
      });
      this.pagination.total = data.length;
    },
    goProduct: function goProduct(id) {
      var routeData = this.$router.resolve({
        path: '/productmanager/productDetail',
        query: {
          id: id
        }
      });
      window.open(routeData.href, '_blank');
      // this.$router.push({path:'productDetail',query:{id: id}})
    }
  }
};